import { usePPDataStoreActions, usePPUpdateCouponStore } from '@haaretz/s-use-pp-data-store';
import { usePPOffsetStepsStoreActions } from '@haaretz/s-use-pp-offset-steps-store';
import { useRouter } from 'next/router';
import useLogout from '../use-logout';
export default function usePpLogout({ onSuccess }) {
    const { clearStore } = usePPDataStoreActions();
    const updateCoupon = usePPUpdateCouponStore();
    const { clearSteps } = usePPOffsetStepsStoreActions();
    const router = useRouter();
    const logout = useLogout({
        onSuccess: async (data)=>{
            // istanbul ignore else
            if (data.success) {
                router.replace({
                    ...router,
                    query: {
                        pathSegment: router.query.pathSegment
                    }
                }, undefined, {
                    shallow: true
                });
                clearStore();
                clearSteps();
                updateCoupon(null);
            }
            // istanbul ignore else
            if (typeof onSuccess === 'function') {
                onSuccess(data);
            }
        }
    });
    return logout;
}

//# sourceMappingURL=usePpLogout.js.map